import type { Thread, ThreadDTO, DmMessage, MessageDTO } from '../types';

export const toThread = (t: ThreadDTO): Thread => ({
  peer: {
    id: t.peer.id,
    displayName: (t.peer as any).displayName ?? 'Unknown Student',
    profileImage: (t.peer as any).profileImage ?? null,
  },
  lastMessage: {
    ...(t.lastMessage as any),
    createdAt: new Date((t.lastMessage as any).createdAt),
  },
  unreadCount: (t as any).unreadCount ?? 0,
});

export const toMessage = (m: MessageDTO): DmMessage => ({
  ...(m as any),
  createdAt: new Date((m as any).createdAt),
});
